
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1uyZT", function(module, exports) {
$parcel$export(module.exports, "RecommendPremiumToStandardModalComponent", () => $3d515e10f99142ca$export$e2ad8f867d457fc6);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $3ZKAH = parcelRequire("3ZKAH");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cxKOj = parcelRequire("cxKOj");

var $eWzpp = parcelRequire("eWzpp");

var $1BZ8a = parcelRequire("1BZ8a");

var $cHtIB = parcelRequire("cHtIB");

var $8Q6yE = parcelRequire("8Q6yE");

var $4cTDP = parcelRequire("4cTDP");

var $5tQVZ = parcelRequire("5tQVZ");

var $7jHKK = parcelRequire("7jHKK");

var $c0zsP = parcelRequire("c0zsP");
const $3d515e10f99142ca$var$RecommendPremiumToStandardModalComponentImpl = ()=>{
    const cloudID = (0, $cHtIB.useCloudId)();
    const RecommendPremiumToStandardModalEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudIds: [
                cloudID
            ]
        }), [
        cloudID
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $7jHKK.recommendPremiumToStandardModalEntryPoint), RecommendPremiumToStandardModalEntryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.jiraRecommendPremiumToStandard",
        packageName: "jira-recommend-premium-to-standard-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: "unmount",
        runtimeProps: {}
    });
};
const $3d515e10f99142ca$var$ExperimentWrapper = ({ children: children })=>{
    const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_reverse_trial_ea_updates_during_trial');
    const experimentCohort = (0, $eJOHy.useMemo)(()=>config.get('cohort', 'not-enrolled'), [
        config
    ]);
    if (experimentCohort === (0, $3ZKAH.VARIATION) && (0, $4cTDP.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) return null;
    return children;
};
const $3d515e10f99142ca$export$e2ad8f867d457fc6 = ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const productEntitlementDetails = (0, $8Q6yE.useProductEntitlementDetails)();
    const productKey = projectType && (0, $FhXEJ.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const daysLeft = (0, $5tQVZ.useMemoizedTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0;
    const eligibleDaysLeft = daysLeft === 1 || daysLeft === 3 || daysLeft === 5;
    // dont preload component if not correct edition, software project open, not ccp
    if (!(0, $c0zsP.isProjectTypeAndEditionSupported)(appEditions, project?.type) || billingSourceSystem !== 'CCP' || !eligibleDaysLeft) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d515e10f99142ca$var$ExperimentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d515e10f99142ca$var$RecommendPremiumToStandardModalComponentImpl, null));
};

});
parcelRegister("3ZKAH", function(module, exports) {
$parcel$export(module.exports, "NOT_ENROLLED", () => $38addf99531006d5$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $38addf99531006d5$export$fa04ad826acc90da);

var $bi9FK = parcelRequire("bi9FK");
const $38addf99531006d5$export$3d370c33621572df = 'cohort';
const $38addf99531006d5$export$5b7423264d48ab04 = 'not-enrolled';
const $38addf99531006d5$export$43f367b3e957f219 = 'control';
const $38addf99531006d5$export$9ba2bc3b1bdc1519 = 'experiment';
const $38addf99531006d5$export$fa04ad826acc90da = 'variation';
const $38addf99531006d5$export$6486974e39493fa6 = 'variation-1';
const $38addf99531006d5$export$7d994996134ad562 = 'variation-2';
const $38addf99531006d5$export$795e7d69b248dcd0 = 'variation-3';
const $38addf99531006d5$export$c9c947c57470b787 = 'variation-4';
const $38addf99531006d5$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $38addf99531006d5$export$5b7423264d48ab04,
    $38addf99531006d5$export$43f367b3e957f219,
    $38addf99531006d5$export$9ba2bc3b1bdc1519,
    $38addf99531006d5$export$fa04ad826acc90da,
    $38addf99531006d5$export$6486974e39493fa6,
    $38addf99531006d5$export$7d994996134ad562,
    $38addf99531006d5$export$795e7d69b248dcd0,
    $38addf99531006d5$export$c9c947c57470b787
];
// Use optionalValidExperimentGroups to further restrict the list of cohorts
const $38addf99531006d5$var$getExperimentGroup = (experimentFeatureFlag, validExperimentGroups = $38addf99531006d5$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $bi9FK.getMultivariateFeatureFlag)(experimentFeatureFlag, $38addf99531006d5$export$5b7423264d48ab04, validExperimentGroups);
var $38addf99531006d5$export$2e2bcd8739ae039 = $38addf99531006d5$var$getExperimentGroup;

});
parcelRegister("bi9FK", function(module, exports) {
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $af7a0b2e539364ac$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $af7a0b2e539364ac$export$7064bb599f663d7e);
const $af7a0b2e539364ac$export$f59495b1b7502b33 = (_featureFlagName, defaultValue = false)=>{
    return defaultValue;
};
function $af7a0b2e539364ac$export$757bc67afadef4a0(_featureFlagName, defaultValue, _possibleValues) {
    return defaultValue;
}
function $af7a0b2e539364ac$export$7064bb599f663d7e(_featureFlagName, defaultValue) {
    return defaultValue;
}

});


parcelRegister("7jHKK", function(module, exports) {
$parcel$export(module.exports, "recommendPremiumToStandardModalEntryPoint", () => $b3b1f5b8b7fa4314$export$cfb9acf6e9b90816);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $7EdOl = parcelRequire("7EdOl");

const $b3b1f5b8b7fa4314$export$cfb9acf6e9b90816 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(async ()=>(parcelRequire("s3wo9")).then(({ RecommendPremiumToStandardModalRenderer: RecommendPremiumToStandardModalRenderer })=>RecommendPremiumToStandardModalRenderer), {
        moduleId: "bbcbd999",
        moduleName: "RecommendPremiumToStandardModalRenderer",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudIds: cloudIds })=>({
            queries: {
                getRecommendPremiumToStandardUrlQuery: {
                    parameters: (0, $7EdOl.default),
                    variables: {
                        cloudIds: cloudIds
                    }
                }
            }
        })
});

});
parcelRegister("7EdOl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2f01db175e91553$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69fe8fb3c68aac51b127a79f9deb0faa>>
 * @relayHash fb6abb540a94d80996699945ba34e3c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19bb3736613b2eba6217cd31041e96804ac925bcddac6db684579988efe3b3fc
const $e2f01db175e91553$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19bb3736613b2eba6217cd31041e96804ac925bcddac6db684579988efe3b3fc",
        "metadata": {},
        "name": "RecommendPremiumToStandardModalRendererQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2f01db175e91553$export$2e2bcd8739ae039 = $e2f01db175e91553$var$node;

});

parcelRegister("s3wo9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f9j1j").then(()=>parcelRequire('27N5H'));

});


parcelRegister("c0zsP", function(module, exports) {
$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $776e662aa62bffcd$export$c9a5a2a3868318aa);

var $FhXEJ = parcelRequire("FhXEJ");

var $cblKs = parcelRequire("cblKs");
const $776e662aa62bffcd$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $FhXEJ.toProjectType)(project);
    if (!projectType || projectType !== (0, $FhXEJ.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $cblKs.PREMIUM_EDITION);
};

});



//# sourceMappingURL=async-recommend-premium-to-standard-modal.6933c7dd.js.map
